import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import roles from '../utils/roles';
import { Button } from 'react-bootstrap';

import NewProjectWidget from './NewProjectWidget';
import ProjectPill from './ProjectPill';
import Spinner from './Spinner';

import projectActions from '../actions/projectActionCreators';

require.ensure([], () => {
    require('./PMO.less');
    require('./PMOProjectListWidget.less');
});

class PMOProjectListWidget extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            expanded: true,
            filteredProjects: this.props.unarchivedProjects,
            filterText: "",
            loadActive: true,
            showNewProjectModal: false
        };
    }

    // LIFECYCLE METHODS

    componentDidMount = () => {
        this.refreshProjects();

        window.addEventListener("resize", this.updateDimensions);

        this.setState({
            scrollSize: window.innerHeight - ReactDOM.findDOMNode(this.projectList).offsetTop
        });
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState({
                filteredProjects: this.state.loadActive ? nextProps.unarchivedProjects : nextProps.archivedProjects
        }, () => {
            //filter newly recieved projects using function callback if there is any filter to match against
            this.state.filterText ? this.filterProjects(this.state.filterText) : null;
            }
        );
    }

    componentWillUnmount = () => { window.removeEventListener("resize", this.updateDimensions); }

    // EVENT HANDLERS

    handleAddClick = () => { this.props.newProjectFunction(); }

    handleFilterChange = (event) => {
        this.setState({
            filterText: event.target.value
        }, this.filterProjects(event.target.value));
    }

    handlePillClick = (id) => {
        this.setState({
            activeIndex: id,
            expanded: false
        });

        this.props.handleFunction(this.state.filteredProjects[id]);
    }

    handleRemove = (id) => { this.props.handleRemoveProject(this.props.allProjects[id]); }

    handleShowChange = () => {
        this.setState({
            loadActive: !this.state.loadActive
        }, this.refreshProjects);
    }

    handleToggle = () => { this.setState({ expanded: !this.state.expanded }); }

    // OTHER METHODS

    clearFilter = () => {
        this.setState({
            filteredProjects: this.state.loadActive ? this.props.unarchivedProjects : this.props.archivedProjects,
            filterText: ""
        });
    }

    closeNewTaskModal = () => { this.setState({ showNewProjectModal: false }); }

    filterProjects = (input) => {
        let filter = new RegExp(input, 'i');
        let filteredProjects = this.state.loadActive ? this.props.unarchivedProjects : this.props.archivedProjects;

        this.setState({
            filteredProjects: filteredProjects.filter(project => filter.test(project.name))
        });
    }

    openNewProjectModal = () => { this.setState({ showNewProjectModal: true }); }

    syncAllProjects = () => {
      this.props.dispatch(projectActions.syncProjects());
    }

    refreshProjects = () => {
        if (this.state.loadActive) {
            if (roles.userHasAnyOfRoles(JSON.parse(localStorage.getItem('user')), ['PMO'])) {
                this.props.dispatch(projectActions.pmoLoadUnarchived());
            } else if (roles.userHasAnyOfRoles(JSON.parse(localStorage.getItem('user')), ['PM'])) {
                this.props.dispatch(projectActions.pmLoadUnarchived());
            }
        } else {
            if (roles.userHasAnyOfRoles(JSON.parse(localStorage.getItem('user')), ['PMO'])) {
                this.props.dispatch(projectActions.pmoLoadArchived());
            } else if (roles.userHasAnyOfRoles(JSON.parse(localStorage.getItem('user')), ['PM'])) {
                this.props.dispatch(projectActions.pmLoadArchived());
            }
        }
    }

    updateDimensions = () => {
        this.setState({
            scrollSize: window.innerHeight - ReactDOM.findDOMNode(this.projectList).offsetTop
        });
    }

    // RENDER METHOD

    render = () => {
        let newProjectModal = (
            <NewProjectWidget
                handleClose={this.closeNewTaskModal}
                handleSave={this.props.handleNewProject}
                projectNames={this.props.projectNames}
                />
        );

        return (
            <div style={this.state.expanded ? {"left" : 0} : {}} className="panel panel-aside pmo task-list" >
                {
                    this.state.showNewProjectModal ? newProjectModal : null
                }
                <a onClick={this.handleToggle} style={{zIndex: 0}} className="panel-aside-handle">
                    <span className={this.state.expanded ? "md-chevron-left md-2x" : "md-chevron-right md-2x"}>
                    </span>
                </a>
                <div className="scrollable-div panel-heading">

                    <div>
                        <Button title={this.state.loadActive ? "Switch to archived projects view" : "Switch to active projects view"} onClick={this.handleShowChange}>
                            {this.state.loadActive ? "Active projects" : "Archived projects"}
                        </Button>
                    </div>
                    <br/>
                    <div className="panel-filter">
                        <div className="form-group">
                            <label>Filter:</label>
                            <input onChange={this.handleFilterChange} value={this.state.filterText} type="text" className="form-control" placeholder="Project Name"/>
                            <a style={{"cursor" : "pointer", paddingRight : "10px", paddingTop : "5px"}} onClick={this.clearFilter} className="filter-clear"><span><span className="md-clear"></span></span></a>
                        </div>
                    </div>
                </div>
                <br style={{ lineHeight: "0.35em" }}/>
                <div ref={ref => this.projectList = ref} className="scrollable-div" style={{"position" : "relative", maxHeight: this.state.scrollSize + "px"}}>
                    <div className="panel-body tasks projects">
                        {
                            this.props.projectsLoading
                            ? <Spinner/>
                            : <ul>
                                {
                                    this.state.filteredProjects.map((project, i) => {
                                        if (project && (project.archived === this.state.loadActive)) {
                                            return null;
                                        }

                                        return <ProjectPill
                                                   active={project && this.props.activeProject && this.props.activeProject.id === project.id}
                                                   handleFunction={this.handlePillClick}
                                                   handleRemove={this.handleRemove}
                                                   id={i}
                                                   key={i}
                                                   project={project}
                                                   text={project.name}
                                                   />;
                                    })
                                }
                            </ul>
                        }
                        <br/>
                    </div>
                </div>
            </div>
        );
    }
}

PMOProjectListWidget.propTypes = {
    activeProject: PropTypes.object,
    archivedProjects: PropTypes.array,
    currentUser: PropTypes.object,
    dispatch: PropTypes.func,
    handleFunction: PropTypes.func,
    handleNewProject: PropTypes.func,
    handleRemove: PropTypes.func,
    handleRemoveProject: PropTypes.func,
    isPMO: PropTypes.bool,
    newProjectFunction: PropTypes.func,
    projectsLoading: PropTypes.bool,
    projectNames: PropTypes.array,
    unarchivedProjects: PropTypes.array
};

PMOProjectListWidget.defaultProps = {
    projects: []
};

const mapStateToProps = (state) => {
    return {
        currentUser: state.users.currentUser,
        error: state.users.error,
        isPMO: roles.userHasAnyOfRoles(JSON.parse(localStorage.getItem('user')), ['PMO']),
        projectsLoading: state.projects.loading,
        tasksLoading: state.tasks.loading
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PMOProjectListWidget);



/** WEBPACK FOOTER **
 ** ./src/app/components/PMOProjectListWidget.js
 **/